const collapseContextKey = Symbol("collapseContextKey");

export { collapseContextKey };
//# sourceMappingURL=collapse.mjs.map
